/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;



// WEBPACK FOOTER //
// ./~/instantsearch.js/~/lodash/_baseLodash.js